export const Radio = {
	// Uses the same as checkbox
	// DO NOT OVERWRITE - Create custom
};

export const CustomRadio = {
	tickBorderWidth: '0',
	tickSize: 'var(--epods--checkbox-size-base)',
	tickIconChecked: 'check',
	tickIconIndeterminate: 'remove',
	tickIconFont: 'material-icons',
	labelPadding: 'var(--epods--space-inset-s)',
	labelHPadding: 'var(--epods--checkbox-label-horizontal-padding)',
	labelColor: 'var(--epods--checkbox-label-color)',
	descriptionSize: 'var(--epods--checkbox-caption-size)',
	descriptionHeight: 'var(--epods--checkbox-caption-height)',
	descriptionMargin: 'var(--epods--checkbox-caption-margin)',
	descriptionColor: 'var(--epods--checkbox-caption-color)',
	tickFillDisabled: 'var(--epods--checkbox-tickFillDisabled)',
};

export const CustomRadioColors = {
	// Uses the same as checkbox
	// DO NOT OVERWRITE - Create custom
};
